import { useNavigate } from "react-router-dom";

import { PredictDropzone } from "#modules/quoteRequestLines/PredictDropzone";
import { PageLayout } from "#shared/layouts/PageLayout";
import { ROUTES } from "#shared/routes";
import { Center } from "#shared/view/components/Center";

export const PredictionPage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout title={`Prédiction du coût d'une pièce`} titleIcon="shapeTriangle">
      <Center mt="xl">
        <PredictDropzone
          onSuccess={(quoteRequestId) =>
            navigate(ROUTES.partnerIaPredictionQuoteRequest(quoteRequestId))
          }
        />
      </Center>
    </PageLayout>
  );
};
